/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Copy_TitleInputs */



/**
* | output |
* | --- |
* | "Copy Event/Text" |
*
* @param {Copy_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const copy_title = /** @type {((inputs?: Copy_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Copy_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Copier Evenement/Texte")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ereignis/Text kopieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Copia evento/testo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Скопировать событие/текст")
	if (locale === "es") return /** @type {LocalizedString} */ ("Copiar evento/texto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("复制事件/文本")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベント/テキストをコピー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट/टेक्स्ट कॉपी करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Copiar evento/texto")
	return /** @type {LocalizedString} */ ("Copy Event/Text")
});